(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spring-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  // Initialize Slick Slider
  $('.spring-slider').on('init reInit afterChange', function(event, slick, currentSlide){
    var i = (currentSlide ? currentSlide : 0) + 1;
    var progress = (i / slick.slideCount) * 100;
    document.querySelectorAll('.progress-bar-two').forEach(bar => {
      bar.style.width = progress + '%';
    });
  });

  $('.spring-slider').slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 5000,
    prevArrow: '<button type="button" class="slick-prev"><svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.361328 8.65041C0.131836 8.87013 0 9.17775 0 9.50002C0 9.82228 0.131836 10.125 0.361328 10.3496L8.95508 18.5528C9.42383 19.002 10.166 18.9824 10.6104 18.5137C11.0547 18.0449 11.04 17.3027 10.5713 16.8584L4.09668 10.6719L20.7031 10.6719C21.3525 10.6719 21.875 10.1494 21.875 9.50002C21.875 8.8506 21.3525 8.32814 20.7031 8.32814L4.09668 8.32814L10.5762 2.1465C11.0449 1.69728 11.0596 0.959976 10.6152 0.491226C10.1709 0.0224762 9.42871 0.00782776 8.95996 0.452164L0.366211 8.65529L0.361328 8.65041Z" fill="#65899A"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.5137 10.3496C21.7432 10.1299 21.875 9.82225 21.875 9.49998C21.875 9.17772 21.7432 8.87498 21.5137 8.65038L12.9199 0.44725C12.4512 -0.00196885 11.709 0.0175625 11.2646 0.486313C10.8203 0.955063 10.835 1.69725 11.3037 2.14159L17.7783 8.32811H1.17188C0.522461 8.32811 0 8.85057 0 9.49998C0 10.1494 0.522461 10.6719 1.17188 10.6719H17.7783L11.2988 16.8535C10.8301 17.3027 10.8154 18.04 11.2598 18.5088C11.7041 18.9775 12.4463 18.9922 12.915 18.5478L21.5088 10.3447L21.5137 10.3496Z" fill="#65899A"/></svg></button>',
    appendArrows: '.slider_arrorws'
  });

  // Function to adjust bottom offset of arrows
  function updateArrowPosition() {
    const slideContents = document.querySelectorAll(".spring-slider-wrapper .spring-slide .slide-content");
    const arrows = document.querySelector(".spring-slider-wrapper .slider_arrorws");

    if (slideContents.length && arrows) {
      let maxHeight = 0;

      slideContents.forEach(slide => {
        const height = slide.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      const totalBottom = maxHeight + 20; // Add 20px padding
      arrows.style.bottom = `${totalBottom}px`;
    }
  }

  // Initial position update
  updateArrowPosition();

  // Recalculate on window resize
  window.addEventListener("resize", updateArrowPosition);

  // Recalculate after slick events
  $('.spring-slider').on('init reInit afterChange', function () {
    updateArrowPosition();
  });

  // Optional: also delay a recalculation in case of async content
  setTimeout(updateArrowPosition, 500);
});

let contentheight = false;

function checkContentHeight() {
  if (window.innerWidth > 749) return; // Only run for screen widths ≤ 749px

  contentheight = false; // Reset on each check

  $('.spring-slider-wrapper .slide-content p').each(function () {
    if ($(this).outerHeight() > 36) {
      contentheight = true;
    }
  });

  if (contentheight) {
    $('.slick-slide .slide-content').addClass('tall-content');
  } else {
    $('.slick-slide .slide-content').removeClass('tall-content');
  }
}

function checkAnyHeadingIsTwoLine() {
  if (window.innerWidth > 749) return; // Only run for screen widths ≤ 749px

  let hasTwoLineHeading = false;

  $('.slick-slide').each(function () {
    const $heading = $(this).find('.slide-content h2');

    if ($heading.length > 0) {
      const lineHeight = parseFloat($heading.css('line-height'));
      const totalHeight = $heading.outerHeight();

      const lineCount = Math.round(totalHeight / lineHeight);

      if (lineCount >= 2) {
        hasTwoLineHeading = true;
        return false; // exit early
      }
    }
  });

  if (hasTwoLineHeading) {
    $('.slick-slide .slide-content').addClass('tall-heading');
  } else {
    $('.slick-slide .slide-content').removeClass('tall-heading');
  }
}

function handleResizeAndRunChecks() {
  checkContentHeight();
  checkAnyHeadingIsTwoLine();
}

$(document).ready(function () {
  handleResizeAndRunChecks();

  $(window).on('resize', function () {
    handleResizeAndRunChecks();
  });

  $('.spring-slider-wrapper').on('setPosition afterChange', function () {
    handleResizeAndRunChecks();
  });
});



  } catch(e) { console.error(e); }
})();
})();
